module.exports = __webpack_public_path__ + "static/NBC-0e849b3bdd62af532bafc57ff7bf59fe.png";